import { useAppSelector } from "@builder/store/store";
import "./style.scss";
import { useEffect, useState } from "react";

interface PreviewDynamicCSS {
    width: number | string;
    height: number | string;
    top: number | string;
    left: number | string;
}

export default function PreviewLine() {
    const hoveredNode = useAppSelector(state => state.builder.hoveredNode);
    const draggedNode = useAppSelector(state => state.builder.draggedNode);
    const [previewCSS, setPreviewCSS] = useState<PreviewDynamicCSS>({ width: 0, height: 0, top: "50%", left: "50%" });

    const [borderCSS, setBorderCSS] = useState<PreviewDynamicCSS>({ width: 0, height: 0, top: "50%", left: "50%" });
    const thickness = 4;

    useEffect(() => {
        const id = hoveredNode.id;
        const direction = hoveredNode.direction;
        const index = hoveredNode.childIndex;
        if (!id || !direction || index === undefined) return; // todo refactor as in the todo list 8)
        const theDiv = document.getElementById(id);
        if (!theDiv) return;

        const theDivRect = theDiv.getBoundingClientRect();
        setBorderCSS({
            width: theDivRect.width,
            height: theDivRect.height,
            top: theDivRect.top,
            left: theDivRect.left
        });

        const children = [...theDiv.children].filter(child => child.id !== draggedNode);

        // For an empty div with a plus button
        if (children.length === 1 && children[0]?.id == "builder-add-elem-plus") {
            const rect = theDiv.getBoundingClientRect();
            setPreviewCSS({
                width: rect.width * 0.9,
                height: 2,
                top: rect.top + rect.height / 2,
                left: rect.left + rect.width * 0.05
            });
        } // todo refactor as in the todo list 8

        // for a div with children
        else if (children.length > 0 && index != undefined && index != null) {
            if (index >= children.length) {
                const rect = children[children.length - 1].getBoundingClientRect();
                direction === "left"
                    ? setPreviewCSS({ width: thickness, height: rect.height, top: rect.top, left: rect.right })
                    : setPreviewCSS({ width: rect.width, height: thickness, top: rect.bottom, left: rect.left });
            } else {
                const rect = children[index].getBoundingClientRect();
                direction === "left"
                    ? setPreviewCSS({ width: thickness, height: rect.height, top: rect.top, left: rect.left })
                    : setPreviewCSS({ width: rect.width, height: thickness, top: rect.top, left: rect.left });
            }
        }

        // for a div with no children and no plus button
        else {
            const rect = theDiv.getBoundingClientRect();
            setPreviewCSS({
                width: rect.width * 0.9,
                height: 2,
                top: rect.top + rect.height / 2,
                left: rect.left + rect.width * 0.05
            });
        }
    }, [hoveredNode, draggedNode]);

    if (!hoveredNode.id) return null;

    return (
        <>
            <div
                className="builder-preview-border"
                style={{ top: borderCSS.top, left: borderCSS.left, width: borderCSS.width, height: borderCSS.height }}
            />
            <div
                className="builder-preview-line"
                style={{ top: previewCSS.top, left: previewCSS.left, width: previewCSS.width, height: previewCSS.height }}
            />
        </>
    );
}
